import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useRetrievePlayerByUserId } from "./ApiProvider";
import Landing from "./Landing";
import { UserContext } from "./auth/UserProvider";
import { ErrorView } from "./nav/Error";
import { Loading } from "./nav/Loading";
import { PlayerPage } from "./players/PlayerPage";
var Home = function () {
    var _a = useContext(UserContext), contextUser = _a.user, isContextUserLoading = _a.loading;
    var _b = useRetrievePlayerByUserId({ userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk }), isPlayerLoading = _b.isLoading, playerError = _b.error, player = _b.data;
    var loading = isPlayerLoading || isContextUserLoading;
    if (!contextUser && !isContextUserLoading) {
        return _jsx(Landing, {});
    }
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!player || playerError) {
        return _jsx(ErrorView, { error: new Error("Player not found") });
    }
    return _jsx(PlayerPage, { player: player, canViewTeams: true, canModify: true });
};
export default Home;
